import { useCallback } from 'react';

import { isZigzag } from '@common/device-manager';
import { gotoLogin } from '@common/utils';

import { setShouldOpenPopup } from '../constant/local-storage';

interface UseSizeInfoLoginRedirectOptions {
  shouldSetPopupFlag?: boolean;
}

export const useSizeInfoLoginRedirect = (options?: UseSizeInfoLoginRedirectOptions) => {
  const { shouldSetPopupFlag = false } = options ?? {};

  const loginWithRedirect = useCallback(
    (catalogProductId: string) => {
      if (shouldSetPopupFlag) {
        setShouldOpenPopup();
      }

      const redirect_url = encodeURIComponent(
        `zigzag://open/product_detail?browsing_type=NATIVE_BROWSER&catalog_product_id=${catalogProductId}&tab_id=SizeInfoTab&is_single_top=true`,
      );

      if (isZigzag()) {
        window.location.assign(`zigzag://open/login?redirect_url=${redirect_url}`);
      } else {
        gotoLogin({
          redirect_url: window.location.href,
          push_route: true,
        });
      }
    },
    [shouldSetPopupFlag],
  );

  return { loginWithRedirect };
};
